import { FC, useEffect, useState } from "react";
import { Collapse, Spin } from "antd";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import { spacedString} from "@pages/utils/utils";
import CoinsIcon from "@assets/Coins.svg";
import { SDImageCard, SDProgressCard, SDDonutCard } from '../card'
import './occupational-financial.scss'
import {getDisplayValueBasedOnType as getDisplayValue , fixedDecimal} from "@utils/helpers";
import { cloneDeep } from 'lodash'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const OccupationalFinancial: FC<any> = (props) => {
  const dataCardId = "12";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=>{
    console.log("OccupationalFinancial.useEffect");
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }


  const householdVehicleOwnership = props?.data?.householdVehicleOwnership
    ? Object.entries(props?.data?.householdVehicleOwnership).map(([key, val]) => ({
        type: spacedString(key),
        value: val,
      }))
    : [];
  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>
  return (
    <Collapse accordion activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
      <Panel className="title ui-sdoh" header="Financial" key="1" extra={genExtra(dataCardId)} style={{ marginBottom: 8 }}>
        <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
          <div className="ui-sdoh__card-items">
            <SDImageCard title="Average Household Income" image={<img src={CoinsIcon} alt="coins-icon" />} value={getDisplayValue(fixedDecimal(props?.data?.averageHouseholdIncome, 0), "dollar")} />
            <SDProgressCard title="Dual Income Family" value={props?.data?.dualIncomeFamily} />
            <SDProgressCard title="Donations To Charity" value={props?.data?.donationsToCharity} />
            <SDProgressCard title="Below Poverty" value={props?.data?.belowPoverty} />
            <SDProgressCard title="Household Debt" value={props?.data?.householdDebt} />
            <SDProgressCard title="More Than 1 Electronic Device" value={props?.data?.moreThanOneElectronicDevice} />
            <SDDonutCard class="ui-household-vehicle-ownership-card" title="Household Vehicle Ownership" value={householdVehicleOwnership} loading={props.loading}/>
          </div>
        </Spin>
      </Panel>
    </Collapse>
  );
};

export default OccupationalFinancial;
